module.exports = __webpack_public_path__ + "static/media/icon_speach_bubble.d008216d.svg";